/*
 * Copyright    :Copyright© 2022 AOMEI
 * Abstract     :
 * Date         :2024-07-12 11:08:27
 * Author       :
 * LastEditors  :chenjia
 * LastEditTime :2024-07-12 11:10:23
 * FilePath     :\abackup-pay\src\mixins\windowWidthMixin.js
 * RevisionHistory:
 */
export default {
  data() {
    return {
      windowWidth: window.innerWidth
    };
  },
  created() {
    window.addEventListener("resize", this.updateWindowWidth);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.updateWindowWidth);
  },
  methods: {
    updateWindowWidth() {
      this.windowWidth = window.innerWidth;
    }
  }
};
